import { Stack, TableCell, TableRow, Typography } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { EnabledChip } from "routes/system-admin/sso-overview/enabled-chip"

export function DomainIndexRow({ item: entry }) {
    return (
        <TableRow hover data-cy={`sso-estate-domain-${entry.domain}`}>
            <TableCell>
                <Typography variant="subtitle2">{entry.domain}</Typography>
            </TableCell>
            <TableCell>
                <Stack spacing={0.25}>
                    <TruncatedTypography variant="body2">{entry.clientName}</TruncatedTypography>
                    <Typography variant="caption" color="text.secondary">
                        {entry.clientId}
                    </Typography>
                </Stack>
            </TableCell>
            <TableCell>
                <Typography variant="body2">{entry.providerName || "—"}</Typography>
            </TableCell>
            <TableCell>
                <EnabledChip enabled={entry.ssoEnabled} />
            </TableCell>
        </TableRow>
    )
}
